
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { CartSection } from './components/CartSection';

const CartPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <CartSection />
      </main>
      <Footer />
    </div>
  );
};

export default CartPage;
